module.exports = __webpack_public_path__ + "img/not-good.0f39814c.svg";